import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { Loader } from '../../components/loader/Loader';
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import { fetchRegistyNames } from '../../services/manageRegistryService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { createRegistyState, updateRegistryState } from './manageRegistryTypes';
import UpdateRegistry from '../../components/manageRegistryComponents/UpdateRegistry';
import CreateRegistry from '../../components/manageRegistryComponents/CreateRegistry';
import "./ManageRegistry.css";
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

function ManageRegistry() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Manage Registry"
  const CUR_COMPONENT_COMMON="commonPortal";
  const [tabValue,setTabValue] = useState<"1" | "2">("1"); 
  const [showLoader,setShowLoader] = useState<boolean>(false); 
  const [updateRegistryState,setUpdateRegistryState] = useState<updateRegistryState>({
    registryName: "",
    configName: "",
    values: ""
  });
  const [createRegistryState,setCreateRegistryState] = useState<createRegistyState>({
    registryName: "",
    values: ""
  });
  const [registryNameOptions,setRegistryNameOptions] = useState<string[]>([]);
  
  const confirmPopupSuccessMethod = useRef<() => void>();
  const [openConfirmModal,setOpenConfirmModal] = useState<boolean>(false);
  const [confirmPopupMessage,setConfirmPopupMessage] = useState<string>("");
  function openConfirmPopup(message: string, successMethod?: () => void){
    setOpenConfirmModal(true);
    setConfirmPopupMessage(message);
    confirmPopupSuccessMethod.current = successMethod;
  }
  useEffect(() => {
    async function getAndSetRegistryOptions(){
        try{
            setShowLoader(true);
            const registryNames = await fetchRegistyNames();
            setRegistryNameOptions(registryNames);
            setShowLoader(false);
        }catch(err){
            console.log(err);
            openPopup("Error","Something went wrong");
        }
    }
    getAndSetRegistryOptions();
  },[])
  return (
    <>
      <Box sx={{ width: "100%" }} className="manage-registry-parent">
        <TabContext value={tabValue}>
          <Box sx={{ borderColor: "divider" }}>
            <TabList
              onChange={(event,value) => { setTabValue(value)}}
              aria-label="lab API tabs example"
              variant="fullWidth"
            >
              <Tab label={translate(TranslationEnum.manage_registry,"Update Configuration")} value="1" />
              <Tab label={translate(TranslationEnum.manage_registry,"New Configuration")} value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {showLoader ? (
              <Loader />
            ) : (
              <UpdateRegistry
                registryState = {updateRegistryState}
                setRegistryState = {setUpdateRegistryState}
                registryNameOptions = {registryNameOptions}
                openConfirmPopup = {openConfirmPopup}
              />
            )}
          </TabPanel>
          <TabPanel value="2">
            {showLoader ? (
              <Loader />
            ) : (
              <CreateRegistry 
                registryState = {createRegistryState}
                setRegistryState = {setCreateRegistryState}
                registryNameOptions = {registryNameOptions}
                openConfirmPopup = {openConfirmPopup}
              />
            )}
          </TabPanel>
        </TabContext>
      </Box>
      <ConfirmationPopUp
        openConfirmModal = {openConfirmModal}
        setOpenConfirmModal = {setOpenConfirmModal}
        message = {confirmPopupMessage}
        successMethod = {confirmPopupSuccessMethod.current}
       />
    </>
  )
}

export default ManageRegistry